import { useTranslation } from "react-i18next";

type LocaleState = {
  locale: string;
  dayjsLocale: string;
  setLocale: (locale: string) => void;
};

export function useLocaleStore(): LocaleState {
  const { i18n } = useTranslation();
  const setLocale = (locale: string) => {
    i18n.changeLanguage(locale);
  };

  const locale = i18n.resolvedLanguage ?? i18n.language ?? "en-CA";
  const dayjsLocale = locale === "jp" ? "ja" : locale;

  return { locale, dayjsLocale, setLocale };
}
